let WindowOpener = /** @class */ (() => {
    class WindowOpener {
        constructor(win = window, doc = win.document) {
            this.win = win;
            this.doc = doc;
        }
        activate() {
            this.doc.querySelectorAll('[data-window]')
                .forEach(element => this.registerHandler(element));
        }
        registerHandler(element) {
            element.addEventListener('click', event => this.openWindow(element, event));
        }
        openWindow(element, event) {
            const url = this.getUrl(element);
            if (!url)
                return;
            const title = this.getTitle(element);
            event.preventDefault();
            const winWidth = this.win.screen.width;
            const winHeight = this.win.screen.height;
            const width = Math.min(WindowOpener.WIDTH, winWidth);
            const height = Math.min(WindowOpener.HEIGHT, winHeight);
            const pos = this.getCenterPosition(width, height);
            const opts = Object.entries({
                status: 1,
                width,
                height,
                top: pos.top,
                left: pos.left
            })
                .map(entry => entry.join('='))
                .join(',');
            this.win.open(url, title, opts);
        }
        getUrl(element) {
            const winAttr = element.dataset.window;
            if (winAttr)
                return winAttr;
            if (element.tagName.toLocaleLowerCase() === 'a') {
                return element.href;
            }
            return null;
        }
        getTitle(element) {
            const winTitleAttr = element.dataset.windowTitle;
            if (winTitleAttr)
                return winTitleAttr;
            const text = element.innerText.trim();
            if (text.indexOf('\n') < 0)
                return text;
            return '';
        }
        getCenterPosition(w, h) {
            // Source: https://stackoverflow.com/a/16861050
            // Simple calculation did not play well on dual monitors
            const dualScreenLeft = this.win.screenLeft !== undefined ? window.screenLeft : window.screenX;
            const dualScreenTop = this.win.screenTop !== undefined ? window.screenTop : window.screenY;
            const width = this.win.innerWidth
                ? this.win.innerWidth
                : this.doc.documentElement.clientWidth
                    ? document.documentElement.clientWidth : screen.width;
            const height = this.win.innerHeight
                ? this.win.innerHeight
                : document.documentElement.clientHeight
                    ? document.documentElement.clientHeight : screen.height;
            const systemZoom = width / this.win.screen.availWidth;
            const left = (width - w) / 2 / systemZoom + dualScreenLeft;
            const top = (height - h) / 2 / systemZoom + dualScreenTop;
            return { left, top };
        }
    }
    WindowOpener.WIDTH = 600;
    WindowOpener.HEIGHT = 400;
    return WindowOpener;
})();
export { WindowOpener };
